<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="layout--main h-full" :class="[
    layoutTypeClass,
    navbarClasses,
    footerClasses,
    { 'no-scroll': isAppPage },
  ]">
    <vx-tour :steps="steps" v-if="
      !disableThemeTour &&
      windowWidth >= 1200 &&
      mainLayoutType === 'vertical' &&
      verticalNavMenuWidth == 'default'
    " />

    <the-customizer v-if="!disableCustomizer" :footerType="footerType" :hideScrollToTop="hideScrollToTop"
      :navbarType="navbarType" :navbarColor="navbarColor" :routerTransition="routerTransition"
      @toggleHideScrollToTop="toggleHideScrollToTop" @updateFooter="updateFooter" @updateNavbar="updateNavbar"
      @updateNavbarColor="updateNavbarColor" @updateRouterTransition="updateRouterTransition" />

    <v-nav-menu :unreadNotif="unreadNotif" :navMenuItems="navMenuItems" title="Vuexy" parent=".layout--main" />

    <div id="content-area" class="flex flex-col" :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]">
      <div id="content-overlay" />
      <!-- {{ contentAreaClass }} -->
      <!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
        <the-navbar-horizontal :navbarType="navbarType" :class="[
          { 'text-white': isNavbarDark && !isThemeDark },
          { 'text-base': !isNavbarDark && isThemeDark },
        ]" />

        <!-- <div style="height: 62px" v-if="navbarType === 'static'"></div> -->

        <h-nav-menu :class="[
          { 'text-white': isNavbarDark && !isThemeDark },
          { 'text-base': !isNavbarDark && isThemeDark },
        ]" :navMenuItems="navMenuItems" />
      </template>

      <template v-else>
        <the-navbar-vertical :style="{
          height: `${contentAreaClass == 'content-area-full' ? 'auto' : 0}`,
        }" :navbarColor="navbarColor" :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]" />
      </template>
      <!-- /Navbar -->

      <div class="content-wrapper flex-1">
        <div class="router-content w-full h-full m-0">
          <transition :name="routerTransition">
            <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
              class="router-header flex flex-wrap items-center mb-6">
              <div class="content-area__heading" :class="{
                'pr-4 border-0 md:border-r border-solid border-grey-light':
                  $route.meta.breadcrumb,
              }">
                <h2 class="mb-1">{{ routeTitle }}</h2>
              </div>

              <!-- BREADCRUMB -->
              <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route"
                :isRTL="$vs.rtl" />

              <!-- DROPDOWN -->
              <!--     <vs-dropdown vs-trigger-click class="ml-auto md:block hidden cursor-pointer">
                  <vs-button radius icon="icon-settings" icon-pack="feather" />

                  <vs-dropdown-menu class="w-32">
                    <vs-dropdown-item>
                      <div @click="$router.push('/pages/profile').catch(() => {})" class="flex items-center">
                        <feather-icon icon="UserIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Profile</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div @click="$router.push('/apps/todo').catch(() => {})" class="flex items-center">
                        <feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Tasks</span>
                      </div>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                      <div @click="$router.push('/apps/email').catch(() => {})" class="flex items-center">
                        <feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                        <span>Inbox</span>
                      </div>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>

                </vs-dropdown> -->
            </div>
          </transition>
          <vs-popup title="High Priority Alert" :active.sync="popupActive">
            <vs-button @click="navigateToSettings">View Alerts</vs-button>
            <br />
            <vs-list v-for="(notif, i) in newNotifications" :key="i">
              <vs-list-item :title="notif.title" :subtitle="notif.msg"></vs-list-item>
            </vs-list>
          </vs-popup>
          <div class="content-area__content w-full h-full flex">
            <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500"
              v-if="!hideScrollToTop">
              <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
            </back-to-top>

            <transition :name="routerTransition" mode="out-in">
              <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="
                (classesStr) => $emit('setAppClasses', classesStr)
              " />
            </transition>
          </div>
        </div>
      </div>
      <the-footer />
    </div>
  </div>
</template>

<script>
import BackToTop from 'vue-backtotop';
import HNavMenu from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue';

import TheCustomizer from '@/layouts/components/customizer/TheCustomizer.vue';
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue';
import TheNavbarVertical from '@/layouts/components/navbar/TheNavbarVertical.vue';
import TheFooter from '@/layouts/components/TheFooter.vue';
import themeConfig from '@/../themeConfig.js';
import VNavMenu from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue';

const VxTour = () => import('@/components/VxTour.vue');

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheCustomizer,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
    VxTour,
  },
  data() {
    return {
      audio: new Audio(require('@/assets/alert.mp3')),
      unreadNotif: 0,
      unreadNotif2: 0,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      unreadNotifications: [],
      newNotifications: [],
      popupActive: false,
      unreadNotifications2: [],
      notificationIntervalId: null,
      notificationStartTimeoutId: null,
      sessionCheckIntervalId: null,
      isNotificationsRequestInFlight: false,
      previousUnreadNotif: null,
      previousUnreadNotif2: null,
      disableCustomizer: themeConfig.disableCustomizer,
      disableThemeTour: themeConfig.disableThemeTour,
      dynamicWatchers: {},
      footerType: themeConfig.footerType || 'static',
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || '#fff',
      navbarType: themeConfig.navbarType || 'floating',
      navMenuItems: [],
      routerTransition: themeConfig.routerTransition || 'none',
      routeTitle: this.$route.meta.pageTitle,
      steps: [
        {
          target: '#btnVNavMenuMinToggler',
          content: 'Toggle Collapse Sidebar.',
        },
        {
          target: '.vx-navbar__starred-pages',
          content:
            'Create your own bookmarks. You can also re-arrange them using drag & drop.',
        },
        {
          target: '.i18n-locale',
          content: 'You can change language from here.',
        },
        {
          target: '.navbar-fuzzy-search',
          content: 'Try fuzzy search to visit pages in flash.',
        },
        {
          target: '.customizer-btn',
          content: 'Customize template based on your preference',
          params: {
            placement: 'left',
          },
        },
        {
          target: '.vs-button.buy-now',
          content: 'Buy this awesomeness at affordable price!',
          params: {
            placement: 'top',
          },
        },
      ],
    };
  },
  mounted() {
    let time = 120000;
    if (this.userInfo.username == 'skadmin') {
      time = 15000;
    }
    if (!this.userInfo.api) {
      this.logout();
    }
    const access = (this.userInfo && this.userInfo.access && this.userInfo.access.pages) || [];
    this.navMenuItems = this.buildNavMenu(access);
    this.audio.loop = true;

    // Do not call notifications on first render.
    // Start first fetch only after 30s, then continue by interval.
    this.notificationStartTimeoutId = window.setTimeout(() => {
      this.getNotifications();
      this.notificationIntervalId = window.setInterval(() => {
        this.getNotifications();
      }, time);
      this.notificationStartTimeoutId = null;
    }, 30000);

    // Light session poll so a revoked / suspended login signs out within a
    // minute, and straight away when the tab is focused again.
    window.addEventListener('igt:force-logout', this.logout);
    document.addEventListener('visibilitychange', this.onVisibilityChange);
    window.addEventListener('focus', this.checkSession);
    this.sessionCheckIntervalId = window.setInterval(this.checkSession, 60000);
  },
  computed: {
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.mainLayoutType === 'vertical') {
        if (this.verticalNavMenuWidth === 'default')
          return 'content-area-reduced';
        else if (this.verticalNavMenuWidth === 'reduced')
          return 'content-area-lg';
        else return 'content-area-full';
      } else return 'content-area-full';
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static',
      };
    },
    isAppPage() {
      return this.$route.meta.no_scroll;
    },
    isThemeDark() {
      return this.$store.state.theme === 'dark';
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`;
    },
    mainLayoutType() {
      return this.$store.state.mainLayoutType;
    },
    navbarClasses() {
      return {
        'navbar-hidden': this.navbarType === 'hidden',
        'navbar-sticky': this.navbarType === 'sticky',
        'navbar-static': this.navbarType === 'static',
        'navbar-floating': this.navbarType === 'floating',
      };
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff';
      this.updateNavbarColor(color);
    },
    '$store.state.mainLayoutType'(val) {
      this.setNavMenuVisibility(val);
      this.disableThemeTour = true;
    },
    popupActive: {
      handler(val) {
        if (val == true) {
          if (
            typeof window !== 'undefined' &&
            window.__igtHighPrioBoardActive &&
            this.hasUnackedHighPrioNotifications()
          ) {
            return;
          }
          this.audio.play();
        }
        if (val == false) {
          this.audio.pause();
          this.audio.currentTime = 0;
        }
      },
    },
  },
  methods: {
    hasUnackedHighPrioNotifications() {
      const list = this.unreadNotifications || [];
      for (let i = 0; i < list.length; i++) {
        const item = list[i];
        if (Number(item.readStatus) === 1) continue;
        try {
          const meta =
            typeof item.meta2 === 'string' ? JSON.parse(item.meta2) : item.meta2;
          if (
            meta &&
            typeof meta === 'object' &&
            !Array.isArray(meta) &&
            (meta.highPriority === true ||
              meta.highPriority === 1 ||
              meta.highPriority === '1' ||
              String(meta.highPriority).toLowerCase() === 'true')
          ) {
            return true;
          }
        } catch (_err) {
          /* ignore */
        }
      }
      return false;
    },
    async checkSession() {
      if (document.hidden || !this.userInfo || !this.userInfo.uid) return;
      try {
        // The axios interceptor raises the logout event when flagged.
        await this.$http.get(`session/check/${this.userInfo.uid}`);
      } catch (e) {
        /* network blips must not sign the user out */
      }
    },
    onVisibilityChange() {
      if (!document.hidden) this.checkSession();
    },
    logout() {
      if (localStorage.getItem('accessToken')) {
        localStorage.removeItem('accessToken');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('beaconData');
        localStorage.removeItem('beaconIdsData');
        this.$acl.change('isLoggedOut');
        this.$vs.notify({
          title: 'Logout',
          text: 'Please login again to continue.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
        });
        this.$router.push('pages/login').catch(() => { });
      }

      // Change role on logout. Same value as initialRole of acj.js

      // This is just for demo Purpose. If user clicks on logout -> redirect
      //    this.$router.push('/pages/login').catch(() => {})
    },
    navigateToSettings() {
      this.popupActive = false;
      this.$router.push({ name: 'component-alerts' });
    },
    buildNavMenu(access) {
      const role = this.userInfo && this.userInfo.userRole;
      if (role === 'Supervisor' || role === 'Request desk' || role === 'Lab') {
        return [
          {
            url: '/trips',
            name: 'Trips',
            slug: 'trips',
            i18n: 'Trips',
            icon: 'MapIcon',
          },
          {
            url: '/settings',
            name: 'Settings',
            slug: 'settings',
            i18n: 'Settings',
            icon: 'SettingsIcon',
          },
        ];
      }
      const menu = [
        {
          url: '/dashboard',
          name: 'Analytics',
          slug: 'dashboard-analytics',
          i18n: 'Analytics',
          icon: 'HomeIcon',
          i18n: 'Dashboard',
          tagColor: 'success',
        },
        {
          header: 'UI',
          icon: 'LayersIcon',
          i18n: 'LIVE TRACKING',
          items: [],
        },

        {
          header: 'Pages',
          icon: 'FileIcon',
          i18n: 'Support',
          items: [
            {
              url: '/alerts',
              name: 'Alerts',
              slug: 'component-alerts',
              i18n: 'Alerts',
              tag: this.unreadNotif,
              tagColor: 'success',
              icon: 'AlertTriangleIcon',
            },
            {
              url: '/reminders',
              name: 'Reminders',
              slug: 'component-reminders',
              i18n: 'Reminders',
              tag: this.unreadNotif2,
              tagColor: 'success',
              icon: 'BellIcon',
            },
            {
              url: '/settings',
              slug: 'settings',
              name: 'Settings',
              icon: 'SettingsIcon',
              i18n: 'Settings',
            },
            /* {
    url: '/faq',
    slug: 'page-faq',
    name: 'FAQ',
    icon: 'HelpCircleIcon',
    i18n: 'FAQ/Report Issue'
  }, */
            {
              url: '/admin',
              slug: 'page-account2',
              name: 'Account',
              icon: 'PieChartIcon',
              i18n: 'Admin',
              tagColor: 'success',
            },

          ],
        },
      ];
      // if (access.includes('mapview')) {
      //   menu[1].items.push({
      //     url: '/hybrid',
      //     icon: 'MapIcon',
      //     i18n: 'Vehicle Map',
      //     name: 'Map View',
      //     slug: 'mapview',
      //   });
      // }

      if (access.includes('mapview')) {
        menu[1].items.push({
          url: '/monitor',
          icon: 'MonitorIcon',
          i18n: 'Monitor',
          name: 'Monitor',
          slug: 'monitor',
        });
      }

      if (access.includes('videoview')) {
        menu[1].items.push({
          url: '/video',
          icon: 'VideoIcon',
          i18n: 'Dashcam / MDVR',
          name: 'Dashcam / MDVR',
          slug: 'video',
        });
      }
      // if (access.includes('mapview')) {
      //   menu[1].items.push({
      //     url: '/map',
      //     icon: 'MapIcon',
      //     i18n: 'Vehicle Map',
      //     name: 'Map View',
      //     slug: 'mapview',
      //   });
      // }
      // if (access.includes('tableview')) {
      //   menu[1].items.push({
      //     url: '/table',
      //     icon: 'GridIcon',
      //     i18n: 'Vehicle List',
      //     name: 'Table View',
      //     slug: 'tableview',
      //   });
      // }
      // if (access.includes('hybridview')) {
      //   menu[1].items.push({
      //     url: '/hybrid',
      //     icon: 'CreditCardIcon',
      //     i18n: 'Hybrid View',
      //     name: 'Hybrid View',
      //     slug: 'hybridview',
      //   });
      // }
      // if (access.includes('multiview')) {
      //   menu[1].items.push({
      //     url: '/multi',
      //     icon: 'PackageIcon',
      //     i18n: 'Multi Vehicle',
      //     name: 'Multi View',
      //     slug: 'multiview',
      //   });
      // }
      if (access.includes('playback')) {
        menu[1].items.push({
          url: '/playback',
          icon: 'PlayIcon',
          i18n: 'Playback',
          name: 'Playback',
          slug: 'playback',
        });
      }
      if (access.includes('tms')) {
        menu[1].items.push({
          url: '/trips',
          name: 'Trips',
          slug: 'tms',
          i18n: 'Trips',
          icon: 'TruckIcon',
          tagColor: 'success',
        });
      }
      if (access.includes('fms')) {
        menu[1].items.push({
          url: '/maintenance',
          name: 'Maintenance',
          slug: 'maintenance',
          i18n: 'Maintenance',
          icon: 'ToolIcon',
        });
      }

      if (this.userInfo.uid == 1 || access.includes('vms')) {
        menu[1].items.push({
          url: '/vms-dashboard',
          name: 'Vessel',
          slug: 'vms-dashboard',
          i18n: 'Vessel',
          icon: 'CompassIcon',
        });
      }
      if (access.includes('reports')) {
        menu[1].items.push({
          url: '/reports',
          name: 'Reports',
          slug: 'reports',
          i18n: 'Reports',
          icon: 'CopyIcon',
          i18n: 'Reports',
        });
        menu[1].items.push({
          url: '/reports-alternate',
          name: 'Reports V2',
          slug: 'reports-alternate',
          i18n: 'Reports V2',
          icon: 'CopyIcon',
          tagColor: 'success',
        });
      }
      return menu;
    },
    updateNavBadgeCounts() {
      if (!Array.isArray(this.navMenuItems) || this.navMenuItems.length < 3) return;
      const nextMenu = this.navMenuItems.map((entry) => {
        if (!entry || !Array.isArray(entry.items)) return entry;
        const nextItems = entry.items.map((item) => {
          if (!item || !item.slug) return item;
          if (item.slug === 'component-alerts') {
            return { ...item, tag: this.unreadNotif };
          }
          if (item.slug === 'component-reminders') {
            return { ...item, tag: this.unreadNotif2 };
          }
          return item;
        });
        return { ...entry, items: nextItems };
      });
      this.navMenuItems = nextMenu;
    },
    async getNotifications() {
      if (this.isNotificationsRequestInFlight) {
        return;
      }
      this.isNotificationsRequestInFlight = true;
      try {
        const response = await this.$http.get(
          `personals/notifications/${this.userInfo.uid}`,
        );
        const nextUnreadNotif = Number(response.data.unreadNotifications || 0);
        const nextUnreadNotif2 = Number(response.data.unreadNotifications2 || 0);
        const prevUnreadNotif =
          this.previousUnreadNotif === null ? this.unreadNotif : this.previousUnreadNotif;
        const prevUnreadNotif2 =
          this.previousUnreadNotif2 === null ? this.unreadNotif2 : this.previousUnreadNotif2;

        this.unreadNotifications = response.data.allNotifications;
        this.unreadNotif = nextUnreadNotif;
        this.newNotifications = response.data.newNotifications;
        this.unreadNotifications2 = response.data.allNotifications2;
        this.unreadNotif2 = nextUnreadNotif2;
        if (response.data.logout && response.data.logout == 1) {
          this.logout();
          return;
        }

        if (this.unreadNotif > prevUnreadNotif && this.unreadNotif != 0) {
          if (
            localStorage.getItem('alert-priority') == true ||
            localStorage.getItem('alert-priority') == 'true'
          ) {
            this.popupActive = true;
          } else {
            this.$vs.notify({
              time: 7000,
              title: 'Alerts',
              text: `You have ${this.unreadNotif} unread alerts.`,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        }

        if (this.unreadNotif2 > prevUnreadNotif2 && this.unreadNotif2 != 0) {
          this.$vs.notify({
            time: 7000,
            title: 'Reminders',
            text: `You have ${this.unreadNotif2} unread reminders.`,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        }

        if (String(localStorage.getItem('unreadNotif')) !== String(this.unreadNotif)) {
          localStorage.setItem('unreadNotif', this.unreadNotif);
        }
        if (String(localStorage.getItem('unreadNotif2')) !== String(this.unreadNotif2)) {
          localStorage.setItem('unreadNotif2', this.unreadNotif2);
        }

        localStorage.setItem(
          'unreadNotifications',
          JSON.stringify(response.data.allNotifications || []),
        );
        localStorage.setItem(
          'unreadNotifications2',
          JSON.stringify(response.data.allNotifications2 || []),
        );

        this.updateNavBadgeCounts();
        this.previousUnreadNotif = this.unreadNotif;
        this.previousUnreadNotif2 = this.unreadNotif2;
      } catch (error) {
        console.log('error from notifications', error);
      } finally {
        this.isNotificationsRequestInFlight = false;
      }
    },
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbar(val) {
      if (val === 'static')
        this.updateNavbarColor(this.isThemeDark ? '#10163a' : '#fff');
      this.navbarType = val;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val === '#fff') this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    updateFooter(val) {
      this.footerType = val;
    },
    updateRouterTransition(val) {
      this.routerTransition = val;
    },
    setNavMenuVisibility(layoutType) {
      if (
        (layoutType === 'horizontal' && this.windowWidth >= 1200) ||
        (layoutType === 'vertical' && this.windowWidth < 1200)
      ) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false);
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu');
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    },
  },
  created() {
    const color =
      this.navbarColor === '#fff' && this.isThemeDark
        ? '#10163a'
        : this.navbarColor;
    this.updateNavbarColor(color);
    this.setNavMenuVisibility(this.$store.state.mainLayoutType);

    // Dynamic Watchers for tour
    // Reason: Once tour is disabled it is not required to enable it.
    // So, watcher is required for just disabling it.
    this.dynamicWatchers.windowWidth = this.$watch(
      '$store.state.windowWidth',
      (val) => {
        if (val < 1200) {
          this.disableThemeTour = true;
          this.dynamicWatchers.windowWidth();
        }
      },
    );

    this.dynamicWatchers.verticalNavMenuWidth = this.$watch(
      '$store.state.verticalNavMenuWidth',
      () => {
        this.disableThemeTour = true;
        this.dynamicWatchers.verticalNavMenuWidth();
      },
    );

    this.dynamicWatchers.rtl = this.$watch('$vs.rtl', () => {
      this.disableThemeTour = true;
      this.dynamicWatchers.rtl();
    });
  },
  beforeDestroy() {
    if (this.notificationStartTimeoutId) {
      clearTimeout(this.notificationStartTimeoutId);
      this.notificationStartTimeoutId = null;
    }
    if (this.notificationIntervalId) {
      clearInterval(this.notificationIntervalId);
      this.notificationIntervalId = null;
    }
    if (this.sessionCheckIntervalId) {
      clearInterval(this.sessionCheckIntervalId);
      this.sessionCheckIntervalId = null;
    }
    window.removeEventListener('igt:force-logout', this.logout);
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
    window.removeEventListener('focus', this.checkSession);
    Object.keys(this.dynamicWatchers).map((i) => {
      this.dynamicWatchers[i]();
      delete this.dynamicWatchers[i];
    });
  },
};
</script>
